import Vue from "vue";
import ApiService from "@/common/api.service";
import { API_PATH } from "@/common/config";

const PATH = "unit-conversions";

export const GET_UNIT_CONVERSIONS = "getUnitConversions";
export const GET_UNIT_CONVERSION = "getUnitConversion";
export const STORE_UNIT_CONVERSION = "storeUnitConversion";
export const UPDATE_UNIT_CONVERSION = "updateUnitConversion";
export const DELETE_UNIT_CONVERSION = "deleteUnitConversion";

export const SET_UNIT_CONVERSIONS_LOADING = "setUnitConversionsLoading";

const state = {
  unitConversionsLoading: false
};

const getters = {
  unitConversionsLoading(state) {
    return state.unitConversionsLoading;
  }
};

const actions = {
  [GET_UNIT_CONVERSIONS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [GET_UNIT_CONVERSION](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [STORE_UNIT_CONVERSION](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [UPDATE_UNIT_CONVERSION](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, params.id, params)
        .then(({ data }) => {
          resolve(data.data);
        })
        .catch(({ response }) => {
          reject(response?.data);
        });
    });
  },

  [DELETE_UNIT_CONVERSION](context, id) {
    return new Promise((resolve, reject) => {
      Vue.axios
        .delete(`${API_PATH}${PATH}/${id}`)
        .then(() => {
          resolve(true);
        })
        .catch((error) => {
          reject(error?.response?.data ?? error);
        });
    });
  },
};

const mutations = {
  [SET_UNIT_CONVERSIONS_LOADING](state, value) {
    state.unitConversionsLoading = value;
  },
};

export default {
  state,
  actions,
  mutations,
  getters
};
